const hasNewDeviceError = (errors: DeserializeError) =>
  errors?.global?.includes('NEW_DEVICE_DETECTED');

export default hasNewDeviceError;
